document.addEventListener('DOMContentLoaded', () => {
  const on24Form = document.getElementsByName('on-24-form');

  if (on24Form.length > 0 && document.getElementById('APassword')) {
    on24Form[0].onsubmit = function (e) {
      if (document.getElementById('APassword').value.length > 0) {
        e.preventDefault();
      }
    };
  }
});
